(ns frontend.actions.task
  (:require
   [frontend.conn :as conn]
   [promesa.core :as p]))

(defn validate-task-fields
  [data]
  (let [assignee (:task/assignee data)
        msg (:task/message data)]
    (case (:task/type data)
      :task.type/simple (and assignee msg (not (empty? msg)))
      assignee)))

;; NOTE
;; Should be one-to-one mapping with domain/task
;; No other tasks should be performed here
;; Should only be required in `events` files
;; Function signatures should always be
;; [data on-success! on-error!]
;; Keep it Simple and Silly

(defn *complete-task->
  [data on-success! on-error!]
  (-> (conn/sendp! :task/complete data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *reactivate-task->
  [data on-success! on-error!]
  (-> (conn/sendp! :task/reactivate data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *create-task->
  [data on-success! on-error!]
  (-> (conn/sendp! :task/create data)
      (p/then on-success!)
      (p/catch on-error!)))
